import { useEffect, useRef } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get or create session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('ltv_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('ltv_session_id', sessionId);
  }
  return sessionId;
};

export const usePageTracking = (pageName) => {
  const tracked = useRef(false);

  useEffect(() => {
    // Prevent double tracking in development (React StrictMode)
    if (tracked.current) return;
    tracked.current = true;

    const trackPageView = async () => {
      try {
        await axios.post(`${API}/analytics/track`, {
          page: pageName,
          referrer: document.referrer || '',
          session_id: getSessionId()
        });
      } catch (err) {
        // Silently fail - analytics shouldn't break the site
        console.debug('Analytics tracking failed:', err);
      }
    };

    trackPageView();
  }, [pageName]);
};

export default usePageTracking;
